// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__gkzSk","amount":"Amount_amount__rF6HT","tip":"Amount_tip__ArZTZ","tipHeader":"Amount_tipHeader__2JmhH","tipsWrap":"Amount_tipsWrap__hDdcm"};